"use client";

import React, {
  useContext, useEffect, useMemo, useState,
} from "react";

import { getCurrencyForCountry } from "../services/countryUtils";
import { Member } from "../models/member";

import AppContext from "./AppContext";
import { useMember } from "./MemberContext";

interface CurrencyContextType {
  currency: string,
}

interface Props {
  children: React.ReactNode;
}

const CurrencyContext = React.createContext<CurrencyContextType>({
  currency: "EUR",
});

const getCurrency = (member: Member, ipCountry: string) => {
  if (member && member.country) {
    return getCurrencyForCountry(member.country);
  }
  if (ipCountry) {
    return getCurrencyForCountry(ipCountry);
  }
  return "EUR";
};

const CurrencyProvider: React.FC<Props> = ({ children }) => {
  const { member } = useMember();
  const { ipCountry } = useContext(AppContext);
  const [currency, setCurrency] = useState(getCurrency(member, ipCountry));

  useEffect(() => {
    setCurrency(getCurrency(member, ipCountry));
  }, [member, ipCountry]);

  const currencyProviderValue = useMemo(() => ({ currency }), [currency]);

  return (
    <CurrencyContext.Provider value={currencyProviderValue}>
      {children}
    </CurrencyContext.Provider>
  );
};

const useCurrency = () => React.useContext(CurrencyContext);

export default CurrencyContext;
export { CurrencyProvider, useCurrency };
